<template>
  <div>
    <div class="new-group">
      <vs-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-input
              type="number"
              class="w-full"
              placeholder="Quantidade"
              label="Quantidade"
              v-model="quantity"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-select class="w-full" label="Tipo" v-model="typeId">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in types"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-select class="w-full" label="Grupo" v-model="groupId">
              <vs-select-item
                :key="index"
                :value="item.idVehicleGroup"
                :text="item.groupName"
                v-for="(item, index) in groups"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full bottom-aligned">
            <vs-button
              color="primary"
              icon="add"
              :disabled="!groupId || !typeId || !quantity"
              @click="addNewTable()"
            >
              Adicionar
            </vs-button>
          </div>
        </div>
      </vs-card>
    </div>
    <div class="type-group" v-for="(vehicle, index) in vehicles" :key="index">
      <vs-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-input
              type="number"
              class="w-full"
              placeholder="Quantidade"
              label="Quantidade"
              v-model="vehicle.quantity"
              @change="calculate()"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-select
              class="w-full"
              label="Tipo"
              v-model="vehicle.typeId"
              @input="onTypeIdChange($event, index)"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in types"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-select
              class="w-full"
              label="Grupo"
              v-model="vehicle.groupId"
              @input="onGroupIdChange($event, index)"
            >
              <vs-select-item
                :key="index"
                :value="item.idVehicleGroup"
                :text="item.groupName"
                v-for="(item, index) in vehicle.allGroups"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-button
              color="danger"
              icon="delete"
              class="mr-3 mb-2"
              @click="removeTable(index)"
              >Remover</vs-button
            >
          </div>
        </div>
        <div
          class="product"
          v-for="table in vehicle.allTables"
          :key="table.idTable"
        >
          <h4>{{ formatName(table.name) }}</h4>
          <div class="radio-container">
            <div
              class="radio-option"
              v-for="value in table.TablesValues"
              :key="value.idTablevalues"
            >
              <vs-radio
                style="z-index: 2"
                color="#2B50BB"
                v-model="selectedValues[table.idTable]"
                :vs-value="value.idTablevalues"
                @change="
                  updateSelected(table.idTable, value.idTablevalues, index)
                "
              ></vs-radio>
              <label>{{ Number(value.initialValue) / 1000 }}K</label>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
    <vs-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mt-3">
          <h6 v-if="!create" class="text-left">
            Total Anual:
            {{ total | currency }}
          </h6>
        </div>
        <div v-if="!finalizada" class="vx-col sm:w-1/2 w-full text-right">
          <div class="">
            <vs-button
              color="success"
              @click="create ? createProductsRcvat() : updateProductsRcvat()"
              >Salvar Produtos</vs-button
            >
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import axios from 'axios';
import dotenv from 'dotenv';
import quotationApiService from '../../services/quotation-api';

export default {
  props: ['dadosProposta', 'quotationData', 'create'],
  watch: {
    dadosProposta() {},
    async typeId() {
      if (!this.quantity || !this.typeId) {
        return;
      }

      this.groups = await this.fetchGroups(this.typeId);
    },
    async quotationData() {
      this.quotationData.vehicles.forEach(async (vehicle, index) => {
        await this.fetchTables(vehicle, index);
        await this.calculate();
      });
    },
  },
  computed: {
    finalizada() {
      if (!this.dadosProposta) {
        return;
      }
      const { idStatus, nomeStatus } = this.dadosProposta;
      return idStatus === 4 && nomeStatus === 'Finalizada';
    },
  },
  mounted() {},
  data() {
    return {
      quantity: null,
      typeId: null,
      groupId: null,
      groups: [],
      selectedValues: [],
      vehicles: [],
      types: [
        {
          text: 'Carro',
          value: 1,
        },
        {
          text: 'Moto',
          value: 2,
        },
        {
          text: 'Caminhão',
          value: 3,
        },
      ],
      quantity: null,
      total: 0,
    };
  },
  methods: {
    async calculate() {
      if (this.vehicles.length == 0) {
        this.total = 0;
        return;
      }

      let quotation = this.quotationData;
      quotation.vehicles = this.vehicles.map((vehicle) => {
        return {
          typeId: vehicle.typeId,
          groupId: vehicle.groupId,
          quantity: Number(vehicle.quantity),
          tables: vehicle.quotationTables.map((table) => {
            return {
              idTable: table.idTable,
              idTablevalues: table.idTablevalues,
            };
          }),
        };
      });

      const params = {
        increases: quotation.increases,
        charges: quotation.charges,
        vehicles: quotation.vehicles,
        beginningValidity: quotation.beginningValidity,
        endingValidity: quotation.endingValidity,
      };

      const calculate = await quotationApiService.calculate(params);
      this.total = calculate.total;
    },
    async updateSelected(idTable, idTablevalues, vehicleIndex) {
      this.$set(this.selectedValues, idTable, idTablevalues);
      let vehicle = this.vehicles[vehicleIndex];

      let updatedTables = vehicle.quotationTables.map((table) => {
        if (table.idTable === idTable) {
          return {
            id: table.id,
            idTable: idTable,
            idTablevalues: idTablevalues,
          };
        }
        return table;
      });

      this.$set(this.vehicles, vehicleIndex, {
        ...vehicle,
        quotationTables: updatedTables,
      });
      await this.calculate();
    },
    formatName(string) {
      return string
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    async fetchTables(vehicle, index) {
      try {
        const token = localStorage.getItem('user-token');
        const allGroups = await this.fetchGroups(vehicle.typeId);
        const tables = await axios.get(
          `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/vehicles/types/${vehicle.typeId}/groups/${vehicle.groupId}/tables`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (vehicle.tables.length === 0) {
          tables.data.forEach((table) => {
            vehicle.tables.push({
              idTable: table.idTable,
              idTablevalues: table.TablesValues[0].idTablevalues,
            });
          });
        }

        this.$set(this.vehicles, index, {
          quantity: vehicle.quantity,
          typeId: vehicle.typeId,
          groupId: vehicle.groupId,
          quotationTables: vehicle.tables,
          allTables: tables.data,
          allGroups: allGroups,
        });
        vehicle.tables.forEach((vehicleTable) => {
          this.selectedValues[vehicleTable.idTable] =
            vehicleTable.idTablevalues;
        });
      } catch (error) {
        console.error('There was an error fetching the tables:', error);
      }
    },
    async fetchGroups(typeId) {
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.get(
          `${process.env.VUE_APP_API_COTACAO_URL}/rcvat/vehicles/types/${typeId}/groups`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        return response.data;
      } catch (error) {
        console.error('There was an error fetching the groups:', error);
      }
    },
    async updateProductsRcvat() {
      if (this.vehicles.length == 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É obrigatório ter no mínimo um produto adicionado.',
          color: 'danger',
        });
        return;
      }

      let quotation = this.quotationData;
      quotation.vehicles = this.vehicles.map((vehicle) => {
        return {
          typeId: vehicle.typeId,
          groupId: vehicle.groupId,
          quantity: Number(vehicle.quantity),
          tables: vehicle.quotationTables.map((table) => {
            return {
              idTable: table.idTable,
              idTablevalues: table.idTablevalues,
            };
          }),
        };
      });
      let quotationUpdated = await quotationApiService.updateRcvatQuotation(
        quotation,
      );
      this.$emit('salvarProdutosRcvat', quotationUpdated);
    },
    async createProductsRcvat() {
      if (this.vehicles.length == 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É obrigatório ter no mínimo um produto adicionado.',
          color: 'danger',
        });
        return;
      }

      let quotation = this.quotationData;
      quotation.vehicles = this.vehicles.map((vehicle) => {
        return {
          typeId: vehicle.typeId,
          groupId: vehicle.groupId,
          quantity: Number(vehicle.quantity),
          tables: vehicle.quotationTables.map((table) => {
            return {
              idTable: table.idTable,
              idTablevalues: table.idTablevalues,
            };
          }),
        };
      });
      this.$emit('salvarProdutosRcvat', quotation);
    },
    async addNewTable() {
      if (!this.quantity || !this.typeId || !this.groupId) {
        return;
      }

      if (this.types.length <= this.vehicles.length) {
        return;
      }

      let vehicle = {
        typeId: this.typeId,
        groupId: this.groupId,
        quantity: this.quantity,
        tables: [],
      };

      this.quantity = null;
      this.typeId = null;
      this.groupId = null;
      let newIndex = this.vehicles.push(vehicle) - 1;
      await this.fetchTables(vehicle, newIndex);
      await this.calculate();
    },
    async removeTable(index) {
      this.vehicles.splice(index, 1);
      await this.calculate();
    },
    onTypeIdChange(typeId, index) {
      this.fetchGroups(typeId).then((groups) => {
        this.$set(this.vehicles, index, {
          ...this.vehicles[index],
          groupId: null,
          allGroups: groups,
          typeId: typeId,
        });
      });
    },
    onGroupIdChange(groupId, index) {
      this.$set(this.vehicles, index, {
        ...this.vehicles[index],
        groupId: groupId,
      });
      this.fetchTables(this.vehicles[index], index);
    },
  },
};
</script>

<style scoped>
.radio-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.radio-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
}

.radio-option:not(:last-child)::after {
  content: '';
  position: absolute;
  top: calc(50% - 15px);
  left: 50%;
  width: 100%;
  height: 8px;
  background-color: #f2f2f2;
  z-index: 1;
}

.vs-radio--borde,
.vs-radio--circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  top: 0;
  background-color: #d8e2ff !important;
}

input[type='radio']:after {
  background-color: #d8e2ff !important;
}

.radio-option label {
  margin-top: 8px;
}

.product > h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.bottom-aligned {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
